import { render, staticRenderFns } from "./DatePickerDemo.vue?vue&type=template&id=4ef671f6&scoped=true&"
import script from "./DatePickerDemo.vue?vue&type=script&lang=js&"
export * from "./DatePickerDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef671f6",
  null
  
)

export default component.exports